"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Pre-baked error boundary component.
 * `getDerivedStateFromError()` has been intentionally omitted as it didn't appear to play well with redux-first-router, and got in the way of reporting current state.
 * <br />
 * <br />
 * This component will also fire off a call to stackdriver if the standard SF stackdriver component has been installed and keys are provided.
 * (The SF component wires up the `window.cakeApp.reportError()` function)
 */
var AppErrorBoundary = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AppErrorBoundary, _React$PureComponent);

  var _super = _createSuper(AppErrorBoundary);

  function AppErrorBoundary() {
    _classCallCheck(this, AppErrorBoundary);

    return _super.apply(this, arguments);
  }

  _createClass(AppErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      var _this$props = this.props,
          appState = _this$props.appState,
          onError = _this$props.onError,
          obfuscationMethod = _this$props.obfuscationMethod; // obfuscate the data - if no function was passed, the original data is returned

      var state = obfuscationMethod(appState); // the stackdriver plugin is a bit locked down in what you can send through,
      // so i am leveraging the message field so that we can send more data through for reporting
      // eslint-disable-next-line no-param-reassign

      error.message = "\n      ".concat(error.message, "\n      State: ").concat(JSON.stringify(state)); // now actually call the logging method, if it exists.  SF should be responsible for setting up this function

      window.cakeApp && window.cakeApp.reportError && window.cakeApp.reportError(error); // eslint-disable-line no-unused-expressions
      // and last, execute any logic that the parent wants us to run when an error is caught.

      onError();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children; // This may be a little counter-intuitive, but it allows us to render out error content as determined by the consuming app

      return children;
    }
  }]);

  return AppErrorBoundary;
}(_react.default.PureComponent);

_defineProperty(AppErrorBoundary, "propTypes", {
  /** If desired, you can pass in app state to pass along to our logs upon a crash - OBFUSCATE */
  appState: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types

  /** content to render within the given error boundary */
  children: _propTypes2.default.children.isRequired,
  // dataTestId is intentionally omitted from this class as it is just a wrapper

  /** obfuscation method - a default method can be located in fe-shared-libs */
  obfuscationMethod: _propTypes.default.func,

  /** method to execute in the event of an error, in addition to logging, if it is enabled */
  onError: _propTypes.default.func
});

_defineProperty(AppErrorBoundary, "defaultProps", {
  appState: undefined,
  obfuscationMethod: function obfuscationMethod(data) {
    return data;
  },
  onError: function onError() {}
});

var _default = AppErrorBoundary;
exports.default = _default;